import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RostrRedirectGuard implements CanActivate {
  canActivate(): boolean {
    window.location.href = '/rostr';
    return false; // Prevent Angular from continuing navigation
  }
}
